<template>
    <div class="comment-wrapper">
        <h3>دیدگاه خود را ارسال کنید</h3>
        <div class="comment-form">
            <form action="#">
                <div class="row row-10">
                    <div class="col-md-6 col-12 section-space--bottom--20">
                        <input type="text" placeholder="نام">
                    </div>
                    <div class="col-md-6 col-12 section-space--bottom--20">
                        <input type="email" placeholder="ایمیل">
                    </div>
                    <div class="col-12">
                        <textarea placeholder="متن دیدگاه"></textarea>
                    </div>
                    <div class="col-12">
                        <input type="submit" value="ارسال دیدگاه">
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    export default {

    };
</script>
